import { IJobSeeker, IBasketOffers } from '../Models';
import { ResponseHelper } from '../Helpers';
import { SecurityApiService } from '.';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const JobSeekerService = {
    async addOffer(reference: string, type: string, profileId: number) {
        const response = await fetch('/Api/JobSeekers/AddOffer', {
            method: 'PUT',
            body: JSON.stringify({
                reference,
                type,
                profileId,
            }),
            headers,
        });

        ResponseHelper.throwIfOnError(response);
    },
    async deleteOffer(reference: string, type: string, profileId: number) {
        const response = await fetch('/Api/JobSeekers/DeleteOffer', {
            method: 'DELETE',
            body: JSON.stringify({
                reference,
                type,
                profileId,
            }),
            headers,
        });

        ResponseHelper.throwIfOnError(response);
    },
    async getAllOffer(): Promise<IBasketOffers> {
        const response = await fetch(
            '/Api/JobSeekers/GetAllOffer?profileId=' + '0',
            {
                method: 'GET',
                headers,
            }
        );

        ResponseHelper.throwIfOnError(response);

        return await response.json();
    },
    async getProfile(): Promise<IJobSeeker> {
        const response = await fetch('/Api/JobSeekers/GetProfile', {
            method: 'GET',
            headers,
        });

        ResponseHelper.throwIfOnError(response);

        return await response.json();
    },
    async isOfferInBasket(
        profileId: number,
        offerReference: string,
        offerType: string
    ): Promise<boolean> {
        const response = await fetch('/Api/JobSeekers/IsOfferInBasket', {
            method: 'POST',
            body: JSON.stringify({
                reference: offerReference,
                type: offerType,
                profileId,
            }),
            headers,
        });

        ResponseHelper.throwIfOnError(response);

        return await response.json();
    },
};
